import {
  POSP,
  POSP_AGREEMENT,
  POSP_DETAILS,
  POSP_EXAM,
  POSP_LEADS,
  POSP_STATUS,
  POSP_TRAINING,
} from '../constants';

export const getProfileState = (flag) => {
  switch (flag) {
    case 0:
      return `/${POSP}/${POSP_DETAILS}`; // pos details does not exist
    case 1:
      return `/${POSP}/${POSP_STATUS}`; // pos details inactive(deactivated)
    case 2:
      return `/${POSP}/${POSP_DETAILS}`; // pos details pending
    case 3:
      return `/${POSP}/${POSP_STATUS}`; // pos details verification in process
    case 4:
      return `/${POSP}/${POSP_TRAINING}`; // pos training data pending
    case 5:
      return `/${POSP}/${POSP_EXAM}`; // pos exam pending
    case 6:
      return `/${POSP}/${POSP_LEADS}`; // pos eligible for business
    case 7:
      return `/${POSP}/${POSP_AGREEMENT}`;
    default:
      return '/';
    //   break;
  }
};
